import React, { ReactNode, useState } from 'react';
import Styles from './GalleryFrame.module.scss';
import classnames from "classnames";
import imageLink from "../../images/smooth_profile.png";
import MainFrame from '../main-frame/MainFrame';
import EditTool from '../edit-tool/EditTool';

import { ReactComponent as PrevPageIcon } from "../../images/icons/prev.svg";
import { ReactComponent as NextPageIcon } from "../../images/icons/next.svg";

interface GalleryFrameProps {
    mainImage?: string;
    theme: string;
    category: string
    photosGallery?: ReactNode;
    numberOfPages?: number;
    currentPage?: number;
    isEditing:boolean;
    onEditClick:()=>void;
    pageClick?: (pageNumber: number) => void;
}
const GalleryFrame = ({ mainImage, theme, category, photosGallery, numberOfPages, currentPage, isEditing, onEditClick, pageClick }: GalleryFrameProps) => {


    const getPageNumbers = () => {
        let pageNumbers = []
        for (let i = 1; i <= numberOfPages; i++) {
            pageNumbers.push(
                <div key={i} className={currentPage === i ? classnames(Styles.page_number, Styles.active) : Styles.page_number} onClick={() => { pageClick(i) }}>
                    {i}
                </div>)
        }

        return pageNumbers
    }

    numberOfPages=Math.ceil(numberOfPages)

    return (
        <div className={classnames(Styles.full_page, "light")} >
            {
                category === "videos"
                    ?
                    <iframe className={Styles.blurred_background_video} src={`${mainImage}?autoplay=1&mute=1`} title="YouTube video player" allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" />
                    :
                    <img className={Styles.blurred_background} src={mainImage} />
            }
            <div className={Styles.left_container}>

                <div className={Styles.main_frame_container}>
                    <MainFrame category={category} url={mainImage} isEditing={isEditing} onEditClick={onEditClick} />
                </div>
                {
                    isEditing && (<div className={Styles.edit_tool_container}>
                        <EditTool />
                    </div>)
                }
            </div>
            <div className={Styles.right_container}>

                <div className={Styles.photos_and_pages}>
                    <div className={Styles.photosGallery}>

                        <div className={Styles.main_gallery_container}>
                            {photosGallery}
                        </div>

                    </div>

                    <div className={Styles.page_navigator}>
                        <button className={currentPage===1?Styles.disabledPageIcon:Styles.pageIcon} onClick={()=>{pageClick(currentPage-1)}}  disabled={currentPage===1}  >
                            <PrevPageIcon />
                        </button>
                        <div className={Styles.pages}>
                            {
                                getPageNumbers()
                            }
                        </div>
                        <button className={currentPage===numberOfPages?Styles.disabledPageIcon:Styles.pageIcon}  onClick={()=>{pageClick(currentPage+1)}}  disabled={currentPage===numberOfPages}  >
                            <NextPageIcon />
                        </button>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default GalleryFrame;

